import { describeNode } from "../lib/index.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  background: '#FEE',
  border: '1px solid red',
  color: 'red',
  padding: '1em',
  margin: '1em 0'
};
export function Unknown(_ref) {
  var {
    node
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    style: styles,
    children: [/*#__PURE__*/_jsx("strong", {
      children: "[@prezly/content-renderer-react-js]"
    }), " Unknown node type encountered:", /*#__PURE__*/_jsx("div", {
      style: {
        fontFamily: 'monospace'
      },
      children: describeNode(node)
    })]
  });
}